function mapDatums(datums) {
    const datumGetters = {};
    datums.forEach((datum) => {
        datumGetters[datum] = function() 
        {
            if (!this.$store.state.components.componentDataPoints[this.componentId]) {
                return 0;
            }

            if (!this.$store.state.components.componentDataPoints[this.componentId][datum]) {
                return 0;
            }

            return this.$store.state.components.componentDataPoints[this.componentId][datum];
        };
    });

    return datumGetters;
}

function mapTotals(datums) {
    const totalGetters = {};

    datums.forEach((datum) => {

        var methodName = 'total' + datum.charAt(0).toUpperCase() + datum.slice(1);
        totalGetters[methodName] = function() {

            var clusterId = this.clusterId;

            if (!this.$store.state.components.clusterTotals[clusterId]) {
                return 0;
            }

            if (!this.$store.state.components.clusterTotals[clusterId][datum]) {
                return 0;
            }

            return this.$store.state.components.clusterTotals[clusterId][datum];
        }
    });


    return totalGetters;
}

export {
    mapDatums,
    mapTotals
}
